export default __webpack_public_path__ + "static/media/default-pot.b3988293.png";